module.exports = {"530481001":"凤麓街道","530481002":"龙街街道","530481101":"右所镇","530481102":"阳宗镇","530481103":"海口镇","530481104":"九村镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530481.json
// module id = 2708
// module chunks = 0